// Foto dei prodotti: niente menu "Salva immagine" né trascinamento (solo un deterrente: sul negozio le foto sono comunque a 1200 px).
document.addEventListener('contextmenu', function (e) {
  if (e.target.closest && e.target.closest('.gallery img, .card .frame img')) e.preventDefault();
});
document.addEventListener('dragstart', function (e) {
  if (e.target.closest && e.target.closest('.gallery img, .card .frame img')) e.preventDefault();
});
